module.exports = __webpack_public_path__ + "img/mobile_bg_portrait.85b1a5f7.jpg";